<ng-container [formGroup]="formGroup">
  <mat-form-field>
    <mat-label>{{ 'Formula' | transloco }}</mat-label>
    <input matInput formControlName="identifier" />
  </mat-form-field>
</ng-container>
